export default "__VITE_ASSET__rysUToRf__"